export default __webpack_public_path__ + "static/media/Podquest.6a82128c.svg";